import { Navigate, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import FAQBot from "./components/FAQBot";
import RoleProtectedRoute from "./components/RoleProtectedRoute";

import Home from "./pages/Home";
import AllServices from "./pages/AllServices";
import Plumber from "./pages/Plumber";
import Electrician from "./pages/Electrician";
import Carpenter from "./pages/Carpenter";
import ACRepair from "./pages/ACRepair";
import Labour from "./pages/Labour";
import MasonMistri from "./pages/MasonMistri";
import SteelRodWireWork from "./pages/SteelRodWireWork";
import Painter from "./pages/Painter";
import TileWorker from "./pages/TileWorker";
import Welder from "./pages/Welder";
import POPFalseCeilingWorker from "./pages/POPFalseCeilingWorker";
import BorePumpTechnician from "./pages/BorePumpTechnician";
import RooftopWaterproofingWorker from "./pages/RooftopWaterproofingWorker";
import Fabricator from "./pages/Fabricator";
import AluminiumWorker from "./pages/AluminiumWorker";
import GlassFitter from "./pages/GlassFitter";
import ModularKitchenInstaller from "./pages/ModularKitchenInstaller";
import DoorWindowFitter from "./pages/DoorWindowFitter";
import CCTVTechnician from "./pages/CCTVTechnician";
import SolarTechnician from "./pages/SolarTechnician";
import Helper from "./pages/Helper";

import WashingMachineRepair from "./pages/WashingMachineRepair";
import RefrigeratorRepair from "./pages/RefrigeratorRepair";
import MicrowaveRepair from "./pages/MicrowaveRepair";
import WaterPurifierRepair from "./pages/WaterPurifierRepair";
import GeyserRepair from "./pages/GeyserRepair";
import ChimneyService from "./pages/ChimneyService";
import TVRepair from "./pages/TVRepair";
import LaptopBasicSupport from "./pages/LaptopBasicSupport";

import Gardening from "./pages/Gardening";
import HouseMaid from "./pages/HouseMaid";
import CookChef from "./pages/CookChef";
import DogCare from "./pages/DogCare";
import CarCleaning from "./pages/CarCleaning";
import NannyCaretaker from "./pages/NannyCaretaker";
import HomeTutor from "./pages/HomeTutor";
import YogaInstructor from "./pages/YogaInstructor";
import InstaHelp from "./pages/InstaHelp";

import Materials from "./pages/Materials";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Membership from "./pages/Membership";
import BuildYourHouse from "./pages/BuildYourHouse";

import Booking from "./pages/Booking";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerifyOtp from "./pages/VerifyOtp";
import ForgotAccess from "./pages/ForgotAccess";
import OtpRecoveryVerify from "./pages/OtpRecoveryVerify";
import ChangePassword from "./pages/ChangePassword";

import MyBookings from "./pages/MyBookings";
import WorkerDetails from "./pages/WorkerDetails";
import Shops from "./pages/Shops";
import VendorDetails from "./pages/VendorDetails";
import RequestService from "./pages/RequestService";
import Settings from "./pages/Settings";
import ProfessionalServiceLanding from "./pages/ProfessionalServiceLanding";
import { professionalServices } from "./data/services/professionalServices";

import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

import ShopOwnerDashboard from "./pages/ShopOwnerDashboard";
import WorkerDashboard from "./pages/WorkerDashboard";
import WorkerWallet from "./pages/WorkerWallet";
import ShopWallet from "./pages/ShopWallet";
import CustomerDashboard from "./pages/CustomerDashboard";
import CustomerRateCard from "./pages/CustomerRateCard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettlements from "./pages/AdminSettlements";
import { getDashboardRoute } from "./utils/routeHelpers";
import { useAuth } from "./context/AuthContext";

function DashboardRedirect() {
  const { profile, loading, isLoggedIn } = useAuth();

  if (loading) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDashboardRoute(profile?.role)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <CartProvider>
          <Header />
          <FAQBot />

          <div style={{ background: "#000", minHeight: "100vh" }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<DashboardRedirect />} />
              <Route path="/all-services" element={<AllServices />} />

              <Route path="/plumber" element={<Plumber />} />
              <Route path="/electrician" element={<Electrician />} />
              <Route path="/carpenter" element={<Carpenter />} />
              <Route path="/ac-repair" element={<ACRepair />} />
              <Route path="/labour" element={<Labour />} />
              <Route path="/mason-mistri" element={<MasonMistri />} />
              <Route
                path="/steel-rod-wire-work"
                element={<SteelRodWireWork />}
              />
              <Route path="/painter" element={<Painter />} />
              <Route path="/tile-worker" element={<TileWorker />} />
              <Route path="/welder" element={<Welder />} />
              <Route
                path="/pop-false-ceiling-worker"
                element={<POPFalseCeilingWorker />}
              />
              <Route
                path="/bore-pump-technician"
                element={<BorePumpTechnician />}
              />
              <Route
                path="/rooftop-waterproofing-worker"
                element={<RooftopWaterproofingWorker />}
              />
              <Route path="/fabricator" element={<Fabricator />} />
              <Route path="/aluminium-worker" element={<AluminiumWorker />} />
              <Route path="/glass-fitter" element={<GlassFitter />} />
              <Route
                path="/modular-kitchen-installer"
                element={<ModularKitchenInstaller />}
              />
              <Route
                path="/door-window-fitter"
                element={<DoorWindowFitter />}
              />
              <Route path="/cctv-technician" element={<CCTVTechnician />} />
              <Route path="/solar-technician" element={<SolarTechnician />} />
              <Route path="/helper" element={<Helper />} />

              <Route
                path="/washing-machine-repair"
                element={<WashingMachineRepair />}
              />
              <Route
                path="/refrigerator-repair"
                element={<RefrigeratorRepair />}
              />
              <Route
                path="/microwave-repair"
                element={<MicrowaveRepair />}
              />
              <Route
                path="/water-purifier-repair"
                element={<WaterPurifierRepair />}
              />
              <Route path="/geyser-repair" element={<GeyserRepair />} />
              <Route path="/chimney-service" element={<ChimneyService />} />
              <Route path="/tv-repair" element={<TVRepair />} />
              <Route
                path="/laptop-basic-support"
                element={<LaptopBasicSupport />}
              />

              <Route path="/gardening" element={<Gardening />} />
              <Route path="/house-maid" element={<HouseMaid />} />
              <Route path="/cook-chef" element={<CookChef />} />
              <Route path="/dog-care" element={<DogCare />} />
              <Route path="/car-cleaning" element={<CarCleaning />} />
              <Route
                path="/nanny-caretaker"
                element={<NannyCaretaker />}
              />
              <Route path="/home-tutor" element={<HomeTutor />} />
              <Route
                path="/yoga-instructor"
                element={<YogaInstructor />}
              />
              <Route path="/insta-help" element={<InstaHelp />} />

              <Route path="/materials" element={<Materials />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/build-your-house" element={<BuildYourHouse />} />

              <Route path="/booking" element={<Booking />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              <Route path="/forgot-access" element={<ForgotAccess />} />
              <Route
                path="/otp-recovery-verify"
                element={<OtpRecoveryVerify />}
              />
              <Route
                path="/change-password"
                element={
                  <RoleProtectedRoute
                    allowedRoles={["customer", "worker", "shop_owner", "admin"]}
                  >
                    <ChangePassword />
                  </RoleProtectedRoute>
                }
              />

              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/worker-details" element={<WorkerDetails />} />
              <Route path="/shops" element={<Shops />} />
              <Route path="/vendor-details" element={<VendorDetails />} />
              <Route path="/request" element={<RequestService />} />
              {professionalServices.map((service) => (
                <Route
                  key={service.slug}
                  path={service.path}
                  element={<ProfessionalServiceLanding service={service} />}
                />
              ))}

              <Route
                path="/customer-dashboard"
                element={
                  <RoleProtectedRoute allowedRoles={["customer"]}>
                    <CustomerDashboard />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/shop-owner-dashboard"
                element={
                  <RoleProtectedRoute allowedRoles={["shop_owner"]}>
                    <ShopOwnerDashboard />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/worker-dashboard"
                element={
                  <RoleProtectedRoute allowedRoles={["worker"]}>
                    <WorkerDashboard />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/worker-wallet"
                element={
                  <RoleProtectedRoute allowedRoles={["worker"]}>
                    <WorkerWallet />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/shop-wallet"
                element={
                  <RoleProtectedRoute allowedRoles={["shop_owner"]}>
                    <ShopWallet />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/admin-dashboard"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <AdminDashboard />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/admin-settlements"
                element={
                  <RoleProtectedRoute allowedRoles={["admin"]}>
                    <AdminSettlements />
                  </RoleProtectedRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <RoleProtectedRoute
                    allowedRoles={["customer", "worker", "shop_owner", "admin"]}
                  >
                    <Settings />
                  </RoleProtectedRoute>
                }
              />

              <Route path="/customer-rate-card" element={<CustomerRateCard />} />

              <Route path="/about" element={<About />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsConditions />}
              />
            </Routes>
          </div>
        </CartProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
